import React, { useState,useEffect } from "react";
import { Menu, ShoppingCart } from "lucide-react";
import { useNavigate,useLocation } from "react-router-dom";

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [active, setActive] = useState("home");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);


   useEffect(() => {
    const path = location.pathname.replace("/", "");
    setActive(path === "" ? "home" : path);
  }, [location]);
  const menuLeft = [
    { id: "", label: "Home" },
    { id: "about-us", label: "About Us" },
    { id: "why-choose-us", label: "Why Choose Us" },
  ];

  const menuRight = [
    { id: "product-overview", label: "Product Overview" },
    { id: "e-store", label: "E-Store" },
    { id: "testimonials", label: "Testimonials" },
  ];

  const handleLinkClick = (id) => {
    setActive(id);
    if (isMobileMenuOpen) {
      setIsMobileMenuOpen(false);
    }
  };

  const allMenuItems = [...menuLeft, ...menuRight];

  return (
    <>
      <style>{`
        .navbar {
         position: fixed;
         top: 0;
         left: 0;
         width: 100%;
         height: 50px;
         display: flex;
         justify-content: space-between;
         align-items: center;
         background: #e9e9e9;
         padding: 0 60px;
         box-sizing: border-box;
         z-index: 1000;
          box-shadow: 0 2px 6px rgba(0,0,0,0.05);
        }
        
        .nav-links {
         list-style: none;
         display: flex;
         align-items: center;
         gap: 0; /* ✅ remove gap, separators will handle spacing */
         margin: 0;
         padding: 0;
        }
        
        .nav-links li {
         display: flex;
         align-items: center;
        }
        
        .nav-links li a {
         width: 100%;
         text-decoration: none;
         color: black;
         font-size: 18px;
         font-weight: 400;
         padding: 13px 35px;
         /* transition: 0.3s; */
         background: #e9e9e9;
        }
        
        .nav-links li a.active {
          font-weight: 700; /* bold active */
        }
        
        .nav-links li a:hover {
          color: #2563eb;
        }
        
        .divider {
         height: 50px;
         width: 3px;
         background: #ffffff;
        }
        
        .logo-container {
         position: absolute;
         top: 0;
         left: 50%;
         transform: translateX(-50%);
         background: #fff;
         padding: 10px 40px;
         border-bottom-left-radius: 20px;
         border-bottom-right-radius: 20px;
         box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        }
        
        .logo {
         height: 50px;
         object-fit: contain;
        }
        
        /* Hide mobile specific elements on desktop */
        .mobile-icon-left,
        .mobile-icon-right,
        .mobile-menu-overlay {
            display: none;
        }
      
        @media (max-width: 992px) {
          /* 1. Navbar Container Redesign */
          .navbar {
            height: 60px;
            padding: 0; /* Removing padding to allow icons to touch edges */
            background: #e9e9e9; /* Light gray background to match image */
            justify-content: space-between;
          }
        
          /* Hide Desktop Links */
          .nav-links {
            display: none;
          }
        
          /* 2. Mobile Icons (Hamburger and Cart) */
          .mobile-icon-left,
          .mobile-icon-right {
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            /* Creating the background box look */
            background: #e9e9e9;
            height: 100%;
            width: 60px;
            position: relative;
            z-index: 1001; /* Above the main navbar plane */
          }
          
          .mobile-icon-left {
              /* Placeholder for Hamburger menu on left */
              left: 0;
          }
          
          .mobile-icon-right {
              /* Placeholder for Cart icon on right */
              right: 0;
          }
          
          /* 3. Logo Container */
          .logo-container {
            position: absolute;
            top: 60%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: #fff;
            border-radius: 0 0 20px 20px;
            padding: 10px 30px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1002;
          }
        
          .logo {
            height: 40px;
            padding-left: 10px;
            padding-right: 10px;
            align-items: center;
            justify-content: center;
          }
        
          /* 4. Mobile Menu Overlay (Hidden by default) */
          .mobile-menu-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: #e9e9e9;
            z-index: 999;
            display: flex;
            flex-direction: column;
            padding-top: 25px;
            // padding: 20px;
            transform: translateX(100%); /* Slide out to the right */
            transition: transform 0.3s ease-in-out;
          }
          
          .mobile-menu-overlay.open {
            transform: translateX(0); /* Slide in */
          }
          
          .mobile-menu-header {
              display: flex;
              justify-content: space-between;
              align-items: center;
              // margin-bottom: 40px;
          }
          
          .logo-mobile {
              height: 50px;
              filter: invert(1); /* White logo for dark background */
          }
          
          .close-btn {
              background: none;
              border: none;
              color: white;
              font-size: 40px;
              cursor: pointer;
          }
          
          .mobile-nav-links {
              list-style: none;
              padding: 0;
              text-align: center;
          }
          
          .mobile-nav-links li {
              margin-bottom: 15px;
          }
          
          .mobile-nav-links li a {
              color: #82a8e5ff;
              text-decoration: none;
              font-size: 24px;
              padding: 10px;
              display: block;
              transition: color 0.2s;
          }
          
          .mobile-nav-links li a.active {
              font-weight: bold;
              color: #3b82f6; /* Blue active color */
          }
        }
      `}</style>
      <nav className="navbar">
        {/* 1. Mobile Menu/Hamburger Icon (Visible on Mobile) */}
        <div
          className="mobile-icon-left"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <Menu size={24} color="#000" />
        </div>

        {/* Desktop Links Left (Hidden on Mobile) */}
        <ul className="nav-links left">
          {menuLeft.map((item, i) => (
            <li key={item.id}>
              <a
                href={`/${item.id}`}
                className={active === item.id ? "active" : ""}
                onClick={() => handleLinkClick(item.id)}
              >
                {item.label}
              </a>
              {i < menuLeft.length - 1 && <span className="divider"></span>}
            </li>
          ))}
        </ul>

        {/* ✅ Logo now clickable and redirects to Home */}
        <div className="logo-container">
          <a href="/" onClick={() => handleLinkClick("home")}>
            {/* Using placeholder for logo image */}
            <img src="/assets/logo2.png" alt="Logo" className="logo" />
          </a>
        </div>

        {/* Desktop Links Right (Hidden on Mobile) */}
        <ul className="nav-links right">
          {menuRight.map((item, i) => (
            <li key={item.id}>
              <a
                href={`/${item.id}`}
                className={active === item.id ? "active" : ""}
                onClick={() => handleLinkClick(item.id)}
              >
                {item.label}
              </a>
              {i < menuRight.length - 1 && <span className="divider"></span>}
            </li>
          ))}
        </ul>

        {/* 2. Mobile Cart Icon (Visible on Mobile) */}
        <div
          className="mobile-icon-right"
          onClick={() => navigate("/cart")}
          style={{ cursor: "pointer" }}
        >
          <ShoppingCart size={24} color="#000" />
        </div>

        {/* 3. Full Screen Mobile Menu (Overlay) */}
        <div
          className={`mobile-menu-overlay ${isMobileMenuOpen ? "open" : ""}`}
        >
          <div className="mobile-menu-header">
            <a href="#home" onClick={() => handleLinkClick("home")}>
              {/* Logo in the mobile menu */}
              {/* <img src="/assets/logo.png" alt="Logo" className="logo-mobile" /> */}
            </a>
            <button
              className="close-btn"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              &times; {/* Close icon */}
            </button>
          </div>

          <ul className="mobile-nav-links">
            {allMenuItems.map((item) => (
              <li key={item.id}>
                <a
                  href={`/${item.id}`}
                  className={active === item.id ? "active" : ""}
                  onClick={() => handleLinkClick(item.id)}
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </nav>
    </>
  );
}
